import styles from './index.module.less'
import { Tabs } from 'antd'
import WOTabItemList from './WOTabItemList.tsx'
import { useEffect } from 'react'

import { useShallow } from 'zustand/react/shallow'
import useWorkshopStore from '@/store/workshop.ts'
import useWorkOrderStore, { WORK_ORDER_TABS } from '@/store/workOrder.ts'
import { useNavigate } from 'react-router-dom'
import { useFileUrlPrefix } from 'shj-utils'

const WorkOrderList = props => {
  const [filePrefix] = useFileUrlPrefix()

  const {
    getWorkOrderGroup,
    workOrderData,
    appData,
    workOrderTab,
    setWorkOrderTab,
    workOrderCount,
    getWorkOrderData,
    workOrderLoading,
    workOrderNoMore,
  } = useWorkshopStore(
    useShallow((state: any) => ({
      appData: state.appData,
      workOrderData: state.workOrderData,
      getWorkOrderGroup: state.getWorkOrderGroup,
      workOrderTab: state.workOrderTab,
      setWorkOrderTab: state.setWorkOrderTab,
      workOrderCount: state.workOrderCount,
      getWorkOrderData: state.getWorkOrderData,
      workOrderLoading: state.workOrderLoading,
      workOrderNoMore: state.workOrderNoMore,
    }))
  )

  const { routeWorkOrderItem } = useWorkOrderStore(
    useShallow((state: any) => ({
      routeWorkOrderItem: state.routeWorkOrderItem,
    }))
  )

  const navigate = useNavigate()

  useEffect(() => {
    getWorkOrderGroup()
  }, [])

  const mergeAppData = (data, key) => {
    return (
      data?.map?.(d => {
        const { appName, appIcon } = appData[key]?.find?.(item => d.appCode === item.appCode) || {}
        return { ...d, appName, appIcon }
      }) || []
    )
  }

  const onItemClick = (record, tab) => {
    // navigate('/flow')
    // setTimeout(() => {
    // }, 20)
    console.log('onItemClick', record)
    routeWorkOrderItem(record, navigate, { selectedTabKey: tab })
  }

  const listProps = {
    getDataOfId: id => {
      const tab = WORK_ORDER_TABS[id]
      return {
        filePrefix,
        tab,
        onClick: record => onItemClick(record, tab),
        dataSource: mergeAppData(workOrderData[tab], tab),
        fetchNext: data => getWorkOrderData(tab, { minId: data?.id }),
        loading: workOrderLoading[tab],
        noMore: workOrderNoMore[tab],
      }
    },
  }

  return (
    <div className={styles.workOrderList}>
      <Tabs
        style={{ height: '100%' }}
        tabBarStyle={{ background: '#fff', padding: '0 15px', margin: 0 }}
        activeKey={workOrderTab}
        onChange={key => setWorkOrderTab(key)}
        items={[
          {
            key: WORK_ORDER_TABS[0],
            label: <div>待办工单 {workOrderCount['todoCount']}</div>,
            children: <WOTabItemList {...listProps.getDataOfId(0)} />,
          },
          {
            key: WORK_ORDER_TABS[1],
            label: '已办工单',
            children: <WOTabItemList {...listProps.getDataOfId(1)} />,
          },
          {
            key: WORK_ORDER_TABS[2],
            label: '我发起的',
            children: <WOTabItemList {...listProps.getDataOfId(2)} />,
          },
          {
            key: WORK_ORDER_TABS[3],
            label: '已取消的',
            children: <WOTabItemList {...listProps.getDataOfId(3)} />,
          },
        ]}
      />
    </div>
  )
}

export default WorkOrderList
